// ==============================|| DRIVE ICON ||============================== //

const DriveIcon = ({ color = '#000', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12,22.1c2.7-2.2,4.8-4.3,6.2-6.3s2.1-4,2.1-5.8-.3-2.9-.9-4-1.3-2-2.1-2.7c-.8-.7-1.7-1.2-2.7-1.5s-1.9-.5-2.7-.5-1.7.2-2.7.5-1.9.8-2.7,1.5c-.8.7-1.5,1.6-2.1,2.7s-.9,2.4-.9,4,.7,3.8,2.1,5.8c1.4,2,3.5,4.1,6.2,6.3h.2ZM12,23.8c-3.3-2.4-5.7-4.8-7.3-7.1-1.6-2.3-2.4-4.5-2.4-6.7s.3-3.1.9-4.3,1.3-2.3,2.3-3.1c.9-.8,2-1.5,3.1-1.9,1.2-.4,2.3-.6,3.4-.6s2.3.2,3.4.6c1.2.4,2.2,1,3.1,1.9.9.8,1.7,1.9,2.3,3.1.6,1.2.9,2.7.9,4.3s-.8,4.4-2.4,6.7-4,4.6-7.3,7.1Z"
        style={commonStyle}
      />
      <path
        d="M15,14.7c0,.2,0,.3,0,.5,0,.3.4.5.7.6h1c0,0,.1,0,.2,0,0,0,0,0,0,0,0,0-.2,0-.3,0H7.1c-.2,0-.4,0-.6-.2h.5c.3,0,.5,0,.8,0,.5,0,.9-.3.8-.9h1c0,0,.1,0,.1,0,0,0,0-.2.1-.3,0,0,0,0,0,0-.4-.3-.7-.6-1.1-1,0,0,0-.1,0-.2,0-.4-.3-.7-.7-.7h-.7c.6-1.2,2.2-2.4,4.2-2.5,2.5-.1,4.2,1.3,5,2.7h-.9c-.3,0-.6.2-.7.6,0,0,0,.2-.1.2-.4.3-.7.7-1.1,1,0,0,0,.1,0,.2,0,.2.2.2.3.2.4,0,.7,0,1,0ZM12.9,13.5c.6-.5,1.2-1,1.7-1.5-1.5-1.4-4-1.3-5.5,0,.6.5,1.1,1,1.7,1.5.7-.3,1.3-.3,2,0Z"
        style={commonStyle}
      />
      <path
        d="M11.8,4.3c1.4,0,2.6,1.2,2.5,2.6,0,1.4-1.2,2.6-2.6,2.5-1.4,0-2.5-1.2-2.5-2.6,0-1.4,1.2-2.5,2.6-2.5Z"
        style={commonStyle}
      />
      <path
        d="M16.8,13.6h-1.1c-.2,0-.4-.1-.4-.3,0-.2.1-.4.3-.4h1.8c.2,0,.4.1.5.3,0,.2.1.4.2.6,0,.4,0,.8-.1,1.2-.1.3-.2.4-.6.4h-1.6c-.2,0-.4-.1-.4-.3,0-.3.1-.5.4-.5h1s0,0,0,0c0,0,0,0,0,0h-1c-.2,0-.4-.1-.4-.3,0-.3.1-.5.4-.5h1c0,0,0,0,.1,0,0,0,0,0,0,0Z"
        style={commonStyle}
      />
      <path
        d="M6.9,13.6c0,0,0,0,.1,0h1c.2,0,.3.1.4.3,0,.2,0,.3-.2.4,0,0-.2,0-.3,0h-.9c0,0-.1,0-.2,0,0,0,.1,0,.2,0h.9c.3,0,.4.2.4.4s-.2.4-.4.4h-1.7c-.2,0-.3,0-.4-.2-.2-.2-.2-.5-.2-.8,0-.3,0-.7.1-1s.2-.4.6-.4h1.6c.3,0,.4.2.4.4s-.2.4-.4.4h-1.1s0,0,0,0Z"
        style={commonStyle}
      />
      <path
        d="M6.5,12.4v-1c0-.2.2-.3.4-.3s.4.1.4.3c0,0,0,.1,0,.2-.2.2-.3.4-.4.7-.1.2-.2.2-.4.2Z"
        style={commonStyle}
      />
      <path
        d="M17.2,12.5c-.2,0-.2,0-.3-.1-.2-.3-.3-.5-.5-.8,0,0,0-.2,0-.2.1-.1.3-.2.5-.2.2,0,.3.2.3.4,0,.3,0,.6,0,.9Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default DriveIcon;
